import { useState, useEffect } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import api from '../../utils/api';

const DAYS  = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const TIMES = ['07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00'];

export default function TutorAvailability() {
  const [slots, setSlots]     = useState([]);
  const [notice, setNotice]   = useState(24);
  const [saving, setSaving]   = useState(false);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg]         = useState('');

  useEffect(() => {
    api.get('/tutors/availability').then(r => {
      if (r.data.slots) {
        setSlots(r.data.slots.map(s => ({
          day_of_week: s.day_of_week,
          start_time: s.start_time,
          end_time: s.end_time
        })));
      }
    });
    api.get('/tutors/dashboard').then(r => {
      if (r.data.tutor?.notice_period_hours) setNotice(r.data.tutor.notice_period_hours);
    }).finally(() => setLoading(false));
  }, []);

  const toggle = (day, time) => {
    const startTime = time + ':00';
    const endH = parseInt(time) + 1;
    const endTime = String(endH).padStart(2,'0') + ':00:00';
    const exists = slots.find(s => s.day_of_week===day && s.start_time===startTime);
    if (exists) setSlots(slots.filter(s => !(s.day_of_week===day && s.start_time===startTime)));
    else setSlots([...slots, { day_of_week:day, start_time:startTime, end_time:endTime }]);
  };

  const isSelected = (day, time) => slots.some(s => s.day_of_week===day && s.start_time===time+':00');

  const save = async () => {
    setSaving(true); setMsg('');
    try {
      await api.put('/tutors/availability', { slots, notice_period_hours: notice });
      setMsg('success:Availability saved successfully');
    } catch(err) { setMsg('error:' + (err.response?.data?.message||'Failed')); }
    setSaving(false);
  };

  if (loading) return <DashboardLayout title="Availability"><div className="loading-screen"><div className="spinner"/></div></DashboardLayout>;

  return (
    <DashboardLayout title="Availability" subtitle="Click slots to toggle availability">
      <div className="card" style={{maxWidth:760}}>
        {msg && <div className={'alert ' + (msg.startsWith('success')?'alert-success':'alert-error')} style={{marginBottom:16}}>{msg.replace(/^(success|error):/,'')}</div>}

        <div className="form-group" style={{marginBottom:20}}>
          <label className="form-label">Minimum booking notice</label>
          <select className="form-select" style={{maxWidth:200}} value={notice} onChange={e=>setNotice(parseInt(e.target.value))}>
            <option value={24}>24 hours</option>
            <option value={48}>48 hours</option>
            <option value={72}>72 hours</option>
          </select>
        </div>

        <div style={{overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'separate',borderSpacing:3,minWidth:520}}>
            <thead>
              <tr>
                <th style={{fontSize:'0.72rem',padding:'6px 8px',fontWeight:700,color:'var(--ink-400)',textAlign:'left',minWidth:52}}>Time</th>
                {DAYS.map(d=><th key={d} style={{fontSize:'0.72rem',padding:'6px 4px',fontWeight:700,color:'var(--ink-400)',textAlign:'center',minWidth:52}}>{d.slice(0,3)}</th>)}
              </tr>
            </thead>
            <tbody>
              {TIMES.map(time=>(
                <tr key={time}>
                  <td style={{fontSize:'0.72rem',color:'var(--ink-400)',padding:'3px 8px',whiteSpace:'nowrap'}}>{time}</td>
                  {DAYS.map((_,day)=>(
                    <td key={day} style={{padding:2}}>
                      <button type="button" onClick={()=>toggle(day,time)} style={{
                        width:'100%',height:28,borderRadius:6,border:'none',cursor:'pointer',transition:'all 0.15s',
                        background: isSelected(day,time) ? '#22c97f' : '#f4faf7',
                        boxShadow: isSelected(day,time) ? '0 2px 6px rgba(34,201,127,0.35)' : 'none'
                      }}/>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{marginTop:16,display:'flex',gap:12,alignItems:'center'}}>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? 'Saving...' : 'Save availability'}
          </button>
          <span style={{fontSize:'0.82rem',color:'var(--ink-400)'}}>{slots.length} slot{slots.length!==1?'s':''} selected</span>
        </div>
      </div>
    </DashboardLayout>
  );
}
